import axiosInstance from './api';

// Get moderation queue
export const getModerationQueue = async () => {
  try {
    const response = await axiosInstance.get('/api/moderation/queue');
    console.log('Moderation queue fetched successfully:', response.data);
    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      message: error.message || 'Failed to fetch moderation queue',
      error: error,
    };
  }
};

// Accept post - approve moderation case
export const acceptPost = async (postId) => {
  try {
    console.log('Attempting to accept post:', postId);
    console.log('Auth header:', axiosInstance.defaults.headers.common.Authorization);

    const response = await axiosInstance.post(`/api/moderation/queue/${postId}/approve`, {});
    console.log('Post accepted successfully:', response.data);
    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    console.error('Accept post error details:', error);
    return {
      success: false,
      message: error.message || 'Failed to accept post',
      error: error,
    };
  }
};

// Reject post - reject moderation case
export const rejectPost = async (postId, reason) => {
  try {
    console.log('Attempting to reject post:', postId, 'with reason:', reason);
    console.log('Auth header:', axiosInstance.defaults.headers.common.Authorization);

    const payload = reason ? { reason } : {};
    const response = await axiosInstance.post(`/api/moderation/queue/${postId}/reject`, payload);
    console.log('Post rejected successfully:', response.data);
    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    console.error('Reject post error details:', error);
    return {
      success: false,
      message: error.message || 'Failed to reject post',
      error: error,
    };
  }
};

// Get detailed moderation case (includes context messages for chat)
export const getModerationCaseDetails = async (caseId) => {
  try {
    const response = await axiosInstance.get(`/api/moderation/queue/${caseId}`);
    console.log('Moderation case details fetched successfully:', response.data);
    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      message: error.message || 'Failed to fetch moderation case details',
      error: error,
    };
  }
};
